angular
    .module("uploadPersonalDocument.components", [])
    .component("uploadPersonalDocument", {
        templateUrl: "ng/components/uploadPersonalDocument/uploadPeronalDocument.view.html",
        bindings: {
            userDaCensire: " = ",
            dealerUser: "<",
            ilTransaction: "<",
            uploadFinish: '&?',
            isPostVendita: '<'
        },
        controllerAs: "uploadPersonalDocumentCtrl",
        controller: function accordionUploadDocuments(
            FileUploader,
            $configService,
            $rootScope,
            $timeout,
            $typeDomainService,
            Pf,
            $instantService
        ) {

            var self = this;

            self.$onInit = function () {
                self.mapComuni = $rootScope.comuniMap;
                self.uploadDocumentSelect = "smartphone";
                self.uploadFromSmartphone = true;
                self.loadingStatus = {
                    uploading: false,
                    loadingDataFromCerved: false,
                    savedDataFromCerved: false,
                    loading: false,
                    loadingAddressesList: false,
                    loadingPfList: false,
                    insertingContract: false
                }
                self.userDaCensire = self.userDaCensire;
                self.documentUpload = [];
                self.dropdown = {
                    tipiDocumento: []
                };
                self.getListaDocumenti();
                if (self.userDaCensire.documento.imgDocumentoCfFront ||
                    self.userDaCensire.documento.imgDocumentoCfBack ||
                    self.userDaCensire.documento.imgDocumentoFront ||
                    self.userDaCensire.documento.imgDocumentoBack) {
                    self.uploadDocumentSelect = self.userDaCensire.uploadMethod;
                    if (self.uploadDocumentSelect === "smartphone") {
                        self.uploadFromSmartphone = true;

                    } else {
                        self.uploadFromSmartphone = false;

                    }
                    var temp = {
                        name: self.userDaCensire.documento.imgDocumentoCfFront,
                        type: "imgCf",
                        selected: false,
                        side: 'front',
                        typeDocument: 'CF',
                        downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoCfFront)

                    };
                    self.documentUpload.push(temp);
                    var temp = {
                        name: self.userDaCensire.documento.imgDocumentoCfBack,
                        type: "imgCf",
                        selected: false,
                        side: 'back',
                        typeDocument: 'CF',
                        downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoCfBack)

                    };
                    self.documentUpload.push(temp);

                    var temp = {
                        name: self.userDaCensire.documento.imgDocumentoFront,
                        type: "imgDocument",
                        selected: false,
                        side: 'front',
                        typeDocument: self.userDaCensire.documento.tipo,
                        downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoFront)

                    };
                    self.documentUpload.push(temp);
                    var temp = {
                        name: self.userDaCensire.documento.imgDocumentoBack,
                        type: "imgDocument",
                        selected: false,
                        side: 'back',
                        typeDocument: self.userDaCensire.documento.tipo,
                        downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoBack)

                    };
                    self.documentUpload.push(temp);
                }
            }
            self.uploader = new FileUploader({
                url: "",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
                    "App-Name": $rootScope.portalName
                }
            });

            self.uploadDataFunc = function (item, index, privacy, type, side) {
                var document =
                    arguments.length > 3 && arguments[3] !== undefined ?
                        arguments[3] :
                        false;
                if (item) {
                    self.uploadData = item;
                }
                self.typeTempDocument = type;
                self.isPrivacyUpload = privacy;
                self.uploadDocumenti = document;
                self.currentCodeTypeNameIndex = index;
                self.sideUploaded = side;
            };

            self.finalUpload = function (item) {
                console.log("calling finalUpload");
                self.folderPath = "" + new Date().getTime();
                var url = $configService.getAppConfig().url +
                    "/uni/upload/service-infos/" +
                    encodeURIComponent(self.userDaCensire.cf) +
                    "/54e6297ba7f4c90ebc88e895eebe4f63/PERSONAL_DOCUMENTS";


                for (var int = 0; int < self.uploader.queue.length; int++) {
                    self.uploader.queue[int].url = url;
                }
                self.loadingStatus.uploading = true;
                self.uploader.uploadAll();
            };

            self.generateDownloadLink = function (filename) {
                return $configService.getUrl() +
                    "/uni/download/service-infos/" +
                    encodeURIComponent(self.userDaCensire.cf) +
                    "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
                    filename +
                    "/PERSONAL_DOCUMENTS/?token=" +
                    $configService.getAppConfig().token;

            };
            self.uploader.onWhenAddingFileFailed = function (
                item /*{File|FileLikeObject}*/,
                filter,
                options
            ) {
                console.info("onWhenAddingFileFailed", item, filter, options);
            };

            self.uploader.onAfterAddingFile = function (fileItem) {
                self.disabledForUploadingInProgress = true;
                console.log("fileItem", fileItem);
                self.progresso = 0;
                if (fileItem.file.size > 26214400) {
                    $rootScope.$broadcast("addAlert", {
                        text: "MAXIMUM_FILE_SIZE_EXCEEDED"
                    });
                    fileItem.remove();
                    $("#uploadInput_" + self.currentCodeTypeNameIndex).val("");
                }
                var fileName = fileItem.file.name;
                if (
                    fileName.toLowerCase().indexOf(".png") > -1 ||
                    fileName.toLowerCase().indexOf(".jpg") > -1 ||
                    fileName.toLowerCase().indexOf(".jpeg") > -1 ||
                    fileName.toLowerCase().indexOf(".tiff") > -1 ||
                    fileName.toLowerCase().indexOf(".zip") > -1
                ) {

                    self.uploader.queue[0].progress = 100;
                    if (self.typeTempDocument == "imgCf") {
                        self.visualProgBarCf = true;
                    } else {
                        self.visualProgBarDoc = true;
                    }
                    $timeout(function () {
                        self.progresso = 100;
                    }, 500);
                } else {
                    fileItem.remove();
                    $("#uploadInput_" + self.currentCodeTypeNameIndex).val("");
                    $rootScope.$broadcast("addAlert", {
                        text: "FORMAT_NOT_SUPPORTED"
                    });
                    self.disabledForUploadingInProgress = false;
                }
            };

            self.uploader.onAfterAddingAll = function (addedFileItems) {
                console.info("onAfterAddingAll", addedFileItems);
                self.finalUpload(self.uploadData);
            };

            self.uploader.onBeforeUploadItem = function (item) {
                item.file.name = window.encodeURIComponent(item.file.name);
                item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
                self.disableInput = true;
            };

            self.uploader.onProgressItem = function (fileItem, progress) {
                self.uploadCompleted = false;
            };

            self.uploader.onProgressAll = function (progress) { };

            self.uploader.onSuccessItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                self.loadingStatus.uploading = false;
            };

            self.uploader.onErrorItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                console.info("onErrorItem", fileItem, response, status, headers);
                self.loadingStatus.uploading = false;
                $("#uploadInput_" + self.currentCodeTypeNameIndex).val("");
                $rootScope.$broadcast("addAlert", {
                    text: "ERROR_UPLOADING_FILE"
                });

                self.disableInput = false;
                $timeout(function () {
                    if (self.typeTempDocument == "imgCf") {
                        self.visualProgBarCf = false;
                    } else {
                        self.visualProgBarDoc = false;
                    }

                }, 4000);

                fileItem.remove();
                $("#uploadInput_" + self.currentCodeTypeNameIndex).val("");

            };

            self.uploader.onCancelItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                console.log(status);
            };

            self.uploader.onCompleteItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                console.info("onCompleteItem", fileItem, response, status, headers);
                if (response && response.uploadFileServicePojo && response.uploadFileServicePojo.success) {
                    self.uploadOk = true;
                    console.log(fileItem);
                    var temp = {
                        name: response.uploadFileServicePojo.fileName,
                        type: self.typeTempDocument,
                        selected: false,
                        side: self.sideUploaded,
                        typeDocument: self.userDaCensire.documento.tipo,
                        downloadLink: self.generateDownloadLink(response.uploadFileServicePojo.fileName)

                    };

                    if (self.typeTempDocument == "imgDocument") {
                        if (self.sideUploaded == "front") {
                            self.disabeldUploadFront = true;
                        } else {
                            self.disabeldUploadBack = true;
                        }

                    } else {
                        if (self.sideUploaded == "front") {
                            self.disabeldUploadCfFront = true;
                        } else {
                            self.disabeldUploadCfBack = true;
                        }
                        temp.typeTempDocument = "CF";
                    }

                    self.documentUpload.push(temp);
                    self.documentUpload = self.documentUpload.filter(function (elem) {
                        return elem.name != "";
                    })
                }
                self.uploader.queue = [];

                self.disableInput = false;
                $timeout(function () {
                    if (self.typeTempDocument == "imgCf") {
                        self.visualProgBarCf = false;
                    } else {
                        self.visualProgBarDoc = false;
                    }
                    self.disabledForUploadingInProgress = false;
                }, 4000);
                $("#uploadInput_" + self.currentCodeTypeNameIndex).val("");

            };

            self.uploader.onCompleteAll = function () {
                console.info("onCompleteAll");
                self.uploadCompleted = true;
            };

            self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
                self.uploading = false;
            };

            self.deletePrivacyDocument = function (type) {
                self.typeTempDocument = type;
                self.progresso = 100;
                if (self.typeTempDocument == "imgCf") {
                    self.visualProgBarCf = true;
                    var temp = self.documentUpload.filter(function (elem) {
                        return elem.selected == true && elem.type == "imgCf";
                    })
                    if (temp.length > 1) {
                        self.disabeldUploadCfFront = false;
                        self.disabeldUploadCfBack = false;
                    } else {
                        if (temp[0].side && temp[0].side == "front") {
                            self.disabeldUploadCfFront = false;
                        } else {
                            self.disabeldUploadCfBack = false;
                        }
                    }
                } else {
                    self.visualProgBarDoc = true;
                    var temp = self.documentUpload.filter(function (elem) {
                        return elem.selected == true && elem.type == "imgDocument";
                    })
                    if (temp.length > 1) {
                        self.disabeldUploadFront = false;
                        self.disabeldUploadBack = false;
                    } else {
                        if (temp[0].side && temp[0].side == "front") {
                            self.disabeldUploadFront = false;
                        } else {
                            self.disabeldUploadBack = false;
                        }
                    }
                }
                $timeout(function () {
                    self.progresso = 0;

                }, 200);

                self.documentsToBeDeleted = self.documentUpload.filter(function (elem) {
                    return elem.selected == true;
                });

                var documentRow =
                    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


                self.documentsToBeDeleted.forEach(function (element) {
                    var type = 'PERSONAL_DOCUMENTS'; //tipo di cancellazione es. IL – PERSONAL_DOCUMENT
                    var idObject = encodeURIComponent(self.userDaCensire.cf); // cf  oppure idWfInstance
                    var codiceDocNsil = 'F9F57B1B9DE5245527EE44BB85D3D4992236F1F7'; //es: 052
                    var fileName = element.name; //nome del file

                    $typeDomainService.deleteFile(type, idObject, codiceDocNsil, fileName)
                        .then(function (response) {
                            console.log(response);
                            self.documentUpload = self.documentUpload.filter(function (elem) {
                                return elem.selected != true;
                            })
                        })
                        .catch(function (error) {
                            $rootScope.$broadcast('addAlert', {
                                text: 'ERROR_TEC'
                            });
                        })
                        .finally(function () {

                            $timeout(function () {
                                if (self.typeTempDocument == "imgCf") {
                                    self.visualProgBarCf = false;
                                } else {
                                    self.visualProgBarDoc = false;
                                }
                                self.uploadOk = false;
                            }, 4000);
                        })
                })
            };

            self.startUploadDocument = function () {
                $rootScope.$broadcast("pageLoader", {
                    action: "OPEN"
                });
                var checkOnlyTitolare = self.userDaCensire.titolare.selected && !self.userDaCensire.firmatario.selected
                var person = {
                    cf: self.userDaCensire.cf,
                    nome: self.userDaCensire.nome.toUpperCase(),
                    cognome: self.userDaCensire.cognome.toUpperCase(),
                    telefono: self.dealerUser.tel,
                    documento: {
                        tipo: self.userDaCensire.documento.tipo
                    }
                }

                var inputStartMobileCapture = {
                    persons: [
                        Pf.build(person)
                    ],
                    appIlTransaction: {
                        id: self.ilTransaction
                    },
                    mobile: false
                };
                self.intervalOfRepeatListenMobileCapture = 0;
                var numberOfIteration = 0;
                $instantService.startMobileCapture(inputStartMobileCapture)
                    .then(function (response) {
                        if (response.success) {

                            var inputListenMobileCapture = {
                                id: response.id
                            };

                            var inputForCallBackMobileCapture = {
                                id: response.id,
                                contingencyUpload: self.documentUpload,
                                flagCallFE: "false"
                            }

                            $instantService.callbackMobileCapture(inputForCallBackMobileCapture)
                                .then(function (response) {
                                    self.intervalOfRepeatListenMobileCapture = setInterval(function () {
                                        $instantService.listenMobileCapture(inputListenMobileCapture)
                                            .then(function (response) {
                                                numberOfIteration++;
                                                if (response.success && response.details.uploadCompleted) {
                                                    clearInterval(self.intervalOfRepeatListenMobileCapture);
                                                    $rootScope.$broadcast("pageLoader", {
                                                        action: "CLOSE"
                                                    });
                                                    response.ocrResponse.cf = self.userDaCensire.cf;
                                                    response.ocrResponse.nome = self.userDaCensire.nome == "" ? response.ocrResponse.nome : self.userDaCensire.nome;
                                                    response.ocrResponse.cognome = self.userDaCensire.cognome == "" ? response.ocrResponse.cognome : self.userDaCensire.cognome;
                                                    response.ocrResponse.sesso = self.userDaCensire.sesso;
                                                    response.ocrResponse.documento.enteRilascio = self.userDaCensire.documento.enteRilascio;
                                                    response.ocrResponse.documento.tipo = self.userDaCensire.documento.tipo;
                                                    response.ocrResponse.datiNascita = self.userDaCensire.datiNascita;
                                                    response.ocrResponse.firmatario = self.userDaCensire.firmatario;
                                                    response.ocrResponse.titolare = self.userDaCensire.titolare;

                                                    var luogoDocumento = self.mapComuni.filter(function (element) {
                                                        return element.nome.toUpperCase() == response.ocrResponse.documento.luogo && response.ocrResponse.documento.luogo.toUpperCase()
                                                    });
                                                    response.ocrResponse.documento.luogoEsteso = luogoDocumento[0];
                                                    response.ocrResponse.documento.provincia = luogoDocumento[0] && luogoDocumento[0].sigla;

                                                    var luogoResidenza = self.mapComuni.filter(function (element) {
                                                        return element.nome.toUpperCase() == response.ocrResponse.residenza.comune && response.ocrResponse.residenza.comune.toUpperCase();
                                                    });
                                                    response.ocrResponse.residenza.luogoEsteso = luogoResidenza[0];
                                                    response.ocrResponse.residenza.provincia = luogoResidenza[0] && luogoResidenza[0].sigla;
                                                    response.ocrResponse.residenza.indirizzo = response.ocrResponse.residenza.indirizzo && response.ocrResponse.residenza.indirizzo.split(",")[0];
                                                    response.ocrResponse.residenza.numeroCivico = response.ocrResponse.residenza.numeroCivico;
                                                    response.ocrResponse.uploadMethod = self.uploadDocumentSelect;
                                                    self.userDaCensire = Pf.build(response.ocrResponse);
                                                    self.userDaCensire.documentiCaricati = true;
                                                    if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                                                        self.userDaCensire.residenza.luogoEsteso = "";

                                                    }
                                                    if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                                                        self.userDaCensire.datiNascita.luogoEsteso = "";

                                                    }
                                                    if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                                                        self.userDaCensire.documento.luogoEsteso = "";
                                                    }

                                                }
                                                if (numberOfIteration >= 50) {
                                                    $rootScope.$broadcast("pageLoader", {
                                                        action: "CLOSE"
                                                    });

                                                    $rootScope.$broadcast("addAlert", {
                                                        text: 'ERROR_TIMEOUT_LISTEN_MOBILE'
                                                    });

                                                    clearInterval(self.intervalOfRepeatListenMobileCapture);


                                                }
                                                console.log('Numero di iterazioni', numberOfIteration);
                                                self.uploadFinish();
                                            })
                                            .catch(function (error) {
                                                console.log(error);

                                                $rootScope.$broadcast("pageLoader", {
                                                    action: "CLOSE"
                                                });
                                            })


                                    }, 10000);

                                })
                                .catch(function (error) {
                                    console.log(error);
                                    $rootScope.$broadcast("pageLoader", {
                                        action: "CLOSE"
                                    });

                                    $rootScope.$broadcast("addAlert", {
                                        text: 'ERROR_TIMEOUT_LISTEN_MOBILE'
                                    });
                                })
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.showLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                        });
                    })
                    .finally(function () {

                    });
            }

            self.startUploadDocumentMobile = function () {
                $rootScope.$broadcast("pageLoader", {
                    action: "OPEN"
                });
                self.documentUpload = [];
                var checkOnlyTitolare = self.userDaCensire.titolare.selected && !self.userDaCensire.firmatario.selected
                var person = {
                    cf: self.userDaCensire.cf,
                    nome: self.userDaCensire.nome.toUpperCase(),
                    cognome: self.userDaCensire.cognome.toUpperCase(),
                    telefono: self.dealerUser.tel,
                    documento: {
                        tipo: self.userDaCensire.documento.tipo
                    }
                }

                var inputStartMobileCapture = {
                    persons: [
                        Pf.build(person)
                    ],
                    appIlTransaction: {
                        id: self.ilTransaction
                    },
                    mobile: true
                };
                self.intervalOfRepeatListenMobileCapture = 0;
                var numberOfIteration = 0;
                $instantService.startMobileCapture(inputStartMobileCapture)
                    .then(function (response) {
                        if (response.success) {

                            var inputListenMobileCapture = {
                                id: response.id
                            };


                            self.intervalOfRepeatListenMobileCapture = setInterval(function () {
                                $instantService.listenMobileCapture(inputListenMobileCapture)
                                    .then(function (response) {
                                        numberOfIteration++;
                                        if (response.success && response.details.uploadCompleted) {
                                            clearInterval(self.intervalOfRepeatListenMobileCapture);
                                            $rootScope.$broadcast("pageLoader", {
                                                action: "CLOSE"
                                            });
                                            response.ocrResponse.cf = self.userDaCensire.cf;
                                            response.ocrResponse.nome = self.userDaCensire.nome == "" ? response.ocrResponse.nome : self.userDaCensire.nome;
                                            response.ocrResponse.cognome = self.userDaCensire.cognome == "" ? response.ocrResponse.cognome : self.userDaCensire.cognome;
                                            response.ocrResponse.sesso = self.userDaCensire.sesso;
                                            response.ocrResponse.documento.enteRilascio = self.userDaCensire.documento.enteRilascio;
                                            response.ocrResponse.documento.tipo = self.userDaCensire.documento.tipo;
                                            response.ocrResponse.datiNascita = self.userDaCensire.datiNascita;
                                            response.ocrResponse.firmatario = self.userDaCensire.firmatario;
                                            response.ocrResponse.titolare = self.userDaCensire.titolare;


                                            var luogoDocumento = self.mapComuni.filter(function (element) {
                                                return element.nome.toUpperCase() == response.ocrResponse.documento.luogo && response.ocrResponse.documento.luogo.toUpperCase()
                                            });
                                            response.ocrResponse.documento.luogoEsteso = luogoDocumento[0];
                                            response.ocrResponse.documento.provincia = luogoDocumento[0] && luogoDocumento[0].sigla;

                                            var luogoResidenza = self.mapComuni.filter(function (element) {
                                                return element.nome.toUpperCase() == response.ocrResponse.residenza.comune && response.ocrResponse.residenza.comune.toUpperCase();
                                            });
                                            response.ocrResponse.residenza.luogoEsteso = luogoResidenza[0];
                                            response.ocrResponse.residenza.provincia = luogoResidenza[0] && luogoResidenza[0].sigla;
                                            response.ocrResponse.residenza.indirizzo = response.ocrResponse.residenza.indirizzo && response.ocrResponse.residenza.indirizzo.split(",")[0];
                                            var testCap = luogoResidenza[0] && luogoResidenza[0].cap.some(function (cap) {
                                                return element == response.ocrResponse.residenza.cap;
                                            })
                                            if (!testCap) {
                                                response.ocrResponse.residenza.cap = luogoResidenza[0].cap[0]
                                            }

                                            response.ocrResponse.residenza.numeroCivico = response.ocrResponse.residenza.numeroCivico;
                                            self.userDaCensire = Pf.build(response.ocrResponse);
                                            self.userDaCensire.documentiCaricati = true;
                                            if (self.userDaCensire.residenza.luogoEsteso.nome == "") {

                                                self.userDaCensire.residenza.luogoEsteso = "";

                                            }
                                            if (self.userDaCensire.datiNascita.luogoEsteso.nome == "") {

                                                self.userDaCensire.datiNascita.luogoEsteso = "";

                                            }
                                            if (self.userDaCensire.documento.luogoEsteso.nome == "") {

                                                self.userDaCensire.documento.luogoEsteso = "";
                                            }
                                            var temp = {
                                                name: self.userDaCensire.documento.imgDocumentoCfFront,
                                                type: "imgCf",
                                                selected: false,
                                                side: 'front',
                                                typeDocument: 'CF',
                                                downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoCfFront)

                                            };
                                            self.documentUpload.push(temp);
                                            var temp = {
                                                name: self.userDaCensire.documento.imgDocumentoCfBack,
                                                type: "imgCf",
                                                selected: false,
                                                side: 'back',
                                                typeDocument: 'CF',
                                                downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoCfBack)

                                            };
                                            self.documentUpload.push(temp);

                                            var temp = {
                                                name: self.userDaCensire.documento.imgDocumentoFront,
                                                type: "imgDocument",
                                                selected: false,
                                                side: 'front',
                                                typeDocument: self.userDaCensire.documento.tipo,
                                                downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoFront)

                                            };
                                            self.documentUpload.push(temp);
                                            var temp = {
                                                name: self.userDaCensire.documento.imgDocumentoBack,
                                                type: "imgDocument",
                                                selected: false,
                                                side: 'back',
                                                typeDocument: self.userDaCensire.documento.tipo,
                                                downloadLink: self.generateDownloadLink(self.userDaCensire.documento.imgDocumentoBack)

                                            };
                                            self.documentUpload.push(temp);

                                        }
                                        if (numberOfIteration >= 50) {
                                            $rootScope.$broadcast("pageLoader", {
                                                action: "CLOSE"
                                            });

                                            $rootScope.$broadcast("addAlert", {
                                                text: 'ERROR_TIMEOUT_LISTEN_MOBILE'
                                            });

                                            clearInterval(self.intervalOfRepeatListenMobileCapture);


                                        }
                                        console.log('Numero di iterazioni', numberOfIteration);
                                        self.uploadFinish();
                                    })
                                    .catch(function (error) {
                                        console.log(error);

                                        $rootScope.$broadcast("pageLoader", {
                                            action: "CLOSE"
                                        });
                                    })


                            }, 10000);


                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.showLoader = false;
                        $rootScope.$broadcast("pageLoader", {
                            action: "CLOSE"
                        });
                    })
                    .finally(function () {

                    });
            }


            self.callStartMobile = function () {
                if (self.uploadFromSmartphone) {
                    self.startUploadDocumentMobile();
                } else {
                    self.startUploadDocument();
                }



                self.unlockDocumentFields = true; // abilitazione a porcedere quando tutto è andata bene
            }

            self.check = function (el) {
                el.selected = !el.selected;
            };

            self.trashCanEnabledCf = function () {

                return self.documentUpload.some(function (elem) {
                    return elem.selected === true && elem.type == 'imgCf';
                })
            }
            self.trashCanEnabledDoc = function () {

                return self.documentUpload.some(function (elem) {
                    return elem.selected === true && elem.type == 'imgDocument';
                })
            }

            self.getListaDocumenti = function () {

                $typeDomainService.getDomainSet('RI_DROPDOWN_DOMAINS', 'DOCUMENT_TYPE')
                    .then(function (response) {
                        self.dropdown.tipiDocumento = response.domainList;
                        for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
                            if (self.dropdown.tipiDocumento[i].value == "CAE") {
                                self.dropdown.tipiDocumento[i].order = 40;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "CAI") {
                                self.dropdown.tipiDocumento[i].order = 10;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "CIE") {
                                self.dropdown.tipiDocumento[i].order = 20;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "NCE") {
                                self.dropdown.tipiDocumento[i].order = 30;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "PAM") {
                                self.dropdown.tipiDocumento[i].order = 50;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "PAS") {
                                self.dropdown.tipiDocumento[i].order = 80;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "PAT") {
                                self.dropdown.tipiDocumento[i].order = 60;
                            }
                            if (self.dropdown.tipiDocumento[i].value == "UCO") {
                                self.dropdown.tipiDocumento[i].order = 70;
                            }

                            self.dropdown.tipiDocumento = self.dropdown.tipiDocumento
                                .filter(function (element) {
                                    return element.value != "CAE"
                                })
                        }

                    });
            }
            self.enableButton = function () {
                var cf = 0,
                    doc = 0;
                self.documentUpload.forEach(function (element) {
                    if (element.type == "imgCf") {
                        cf++;
                    } else {
                        doc++;
                    }

                })
                if (cf > 1 && doc > 1) {
                    return true;
                } else {
                    return false;
                }
            }

            self.uploadSelected = function () {
                self.documentUpload = [];
                if (self.uploadDocumentSelect === "smartphone") {
                    self.uploadFromSmartphone = true;

                } else {
                    self.uploadFromSmartphone = false;

                }
                self.userDaCensire.uploadMethod = self.uploadDocumentSelect;
            }

            self.enableButtonMobile = function () {

                return self.uploadFromSmartphone && self.userDaCensire.documento.tipo;
            }
        }
    });